import { Action } from '@ngrx/store';

import { Projects, ProjectsFilter, Role, Sharing, ToggleSharing } from '@usimweb/core/models';

export const LOAD_PROJECTS = '[Projects] Load Projects';
export const LOAD_PROJECTS_FAIL = '[Projects] Load Projects Fail';
export const LOAD_PROJECTS_SUCCESS = '[Projects] Load Projects Success';

export const LOAD_PROJECT = '[Projects] Load Project';
export const LOAD_PROJECT_FAIL = '[Projects] Load Project Fail';
export const LOAD_PROJECT_SUCCESS = '[Projects] Load Project Success';

export const CREATE_PROJECTS = '[PROJECTS] Create projects';
export const CREATE_PROJECTS_FAIL = '[PROJECTS] Create projects Fail';
export const CREATE_PROJECTS_SUCCESS = '[PROJECTS] Create projects Success';

export const DELETE_PROJECT = '[Projects] Delete Project';
export const DELETE_PROJECT_FAIL = '[Projects] Delete Project Fail';
export const DELETE_PROJECT_SUCCESS = '[Projects] Delete Project Success';

export const FAV_PROJECT = '[Projects] Toggle Fav Project Try';
export const FAV_PROJECT_FAIL = '[Projects] Toggle Fav Project Fail';
export const FAV_PROJECT_SUCCESS = '[Projects] Toggle Fav Project Success';

export const REQUEST_SUPPORT = '[Projects] Request support';
export const REQUEST_SUPPORT_FAIL = '[Projects] Request support Fail';
export const REQUEST_SUPPORT_SUCCESS = '[Projects] Request support Success';

export const UNREQUEST_SUPPORT = '[Projects] Unrequest support';
export const UNREQUEST_SUPPORT_FAIL = '[Projects] Unrequest support Fail';
export const UNREQUEST_SUPPORT_SUCCESS = '[Projects] Unrequest support Success';

export const ADD_USER_PROJECT = '[Projects] Add user to project';
export const ADD_USER_PROJECT_FAIL = '[Projects] Add user to project Fail';
export const ADD_USER_PROJECT_SUCCESS = '[Projects] Add user to project Success';

export const RM_USER_PROJECT = '[Projects] Remove user to project';
export const RM_USER_PROJECT_FAIL = '[Projects] Remove user to project Fail';
export const RM_USER_PROJECT_SUCCESS = '[Projects] Remove user to project Success';

export const CHANGE_USER_ROLE = '[Projects] Change user role';
export const CHANGE_USER_ROLE_FAIL = '[Projects] Change user role Fail';
export const CHANGE_USER_ROLE_SUCCESS = '[Projects] Change user role Success';

export const SET_PROJECTS_FILTER = '[Project] Set projects filter';

export const CLEAR_PROJECTS = '[Project] Clear projects';

export class CreateProjects implements Action {
  readonly type = CREATE_PROJECTS;
  constructor(public payload: Projects) {}
}

export class CreateProjectsFail implements Action {
  readonly type = CREATE_PROJECTS_FAIL;
  constructor(public payload: any) {}
}

export class CreateProjectsSuccess implements Action {
  readonly type = CREATE_PROJECTS_SUCCESS;
  constructor(public payload: Projects) {}
}

export class LoadProjects implements Action {
  readonly type = LOAD_PROJECTS;
}

export class LoadProjectsFail implements Action {
  readonly type = LOAD_PROJECTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadProjectsSuccess implements Action {
  readonly type = LOAD_PROJECTS_SUCCESS;
  constructor(public payload: Projects[]) {}
}

export class LoadProject implements Action {
  readonly type = LOAD_PROJECT;
  constructor(public payload: string) {}
}

export class LoadProjectFail implements Action {
  readonly type = LOAD_PROJECT_FAIL;
  constructor(public payload: any) {}
}

export class LoadProjectSuccess implements Action {
  readonly type = LOAD_PROJECT_SUCCESS;
  constructor(public payload: Projects) {}
}

export class DeleteProject implements Action {
  readonly type = DELETE_PROJECT;
  constructor(public payload: Projects) {}
}

export class DeleteProjectFails implements Action {
  readonly type = DELETE_PROJECT_FAIL;
  constructor(public payload: any) {}
}

export class DeleteProjectSuccess implements Action {
  readonly type = DELETE_PROJECT_SUCCESS;
  constructor(public payload: Projects) {}
}

export class FavProject implements Action {
  readonly type = FAV_PROJECT;
  constructor(public payload: Projects) {}
}

export class FavProjectFail implements Action {
  readonly type = FAV_PROJECT_FAIL;
  constructor(public payload: any) {}
}

export class FavProjectSuccess implements Action {
  readonly type = FAV_PROJECT_SUCCESS;
  constructor(public payload: Projects) {}
}

export class RequestSupport implements Action {
  readonly type = REQUEST_SUPPORT;
  constructor(public payload: { uuid: string; reqSupport: {} }) {}
}

export class RequestSupportFail implements Action {
  readonly type = REQUEST_SUPPORT_FAIL;
  constructor(public payload: any) {}
}

export class RequestSupportSuccess implements Action {
  readonly type = REQUEST_SUPPORT_SUCCESS;
  constructor(public payload: Projects) {}
}

export class UnrequestSupport implements Action {
  readonly type = UNREQUEST_SUPPORT;
  constructor(public payload: { uuid: string; request_id: string }) {}
}

export class UnrequestSupportFail implements Action {
  readonly type = UNREQUEST_SUPPORT_FAIL;
  constructor(public payload: any) {}
}

export class UnrequestSupportSuccess implements Action {
  readonly type = UNREQUEST_SUPPORT_SUCCESS;
  constructor(public payload: Projects) {}
}

export class AddUserProjects implements Action {
  readonly type = ADD_USER_PROJECT;
  constructor(public payload: ToggleSharing) {}
}

export class AddUserProjectsFail implements Action {
  readonly type = ADD_USER_PROJECT_FAIL;
  constructor(public payload: any) {}
}

export class AddUserProjectsSuccess implements Action {
  readonly type = ADD_USER_PROJECT_SUCCESS;
  constructor(public payload: Sharing) {}
}

export class RmUserProjects implements Action {
  readonly type = RM_USER_PROJECT;
  constructor(public payload: ToggleSharing) {}
}

export class RmUserProjectsFail implements Action {
  readonly type = RM_USER_PROJECT_FAIL;
  constructor(public payload: any) {}
}

export class RmUserProjectsSuccess implements Action {
  readonly type = RM_USER_PROJECT_SUCCESS;
  constructor(public payload: Sharing) {}
}

export class ChangeUserProjects implements Action {
  readonly type = CHANGE_USER_ROLE;
  constructor(public payload: Role) {}
}

export class ChangeUserProjectsFail implements Action {
  readonly type = CHANGE_USER_ROLE_FAIL;
  constructor(public payload: any) {}
}

export class ChangeUserProjectsSuccess implements Action {
  readonly type = CHANGE_USER_ROLE_SUCCESS;
  constructor(public payload: Role) {}
}

export class SetProjectsFilter implements Action {
  readonly type = SET_PROJECTS_FILTER;
  constructor(public payload: ProjectsFilter) {}
}

export class ClearProjects implements Action {
  readonly type = CLEAR_PROJECTS;
  constructor() {}
}

export type ProjectsAction =
  | LoadProjects
  | LoadProjectsFail
  | LoadProjectsSuccess
  | CreateProjects
  | CreateProjectsFail
  | CreateProjectsSuccess
  | DeleteProject
  | DeleteProjectFails
  | DeleteProjectSuccess
  | FavProject
  | FavProjectFail
  | FavProjectSuccess
  | LoadProjects
  | LoadProjectsFail
  | LoadProjectsSuccess
  | RequestSupport
  | RequestSupportFail
  | RequestSupportSuccess
  | UnrequestSupport
  | UnrequestSupportFail
  | UnrequestSupportSuccess
  | AddUserProjects
  | AddUserProjectsFail
  | AddUserProjectsSuccess
  | RmUserProjects
  | RmUserProjectsFail
  | RmUserProjectsSuccess
  | ChangeUserProjects
  | ChangeUserProjectsFail
  | ChangeUserProjectsSuccess
  | SetProjectsFilter
  | LoadProject
  | LoadProjectFail
  | LoadProjectSuccess
  | ClearProjects;
